// extracted by mini-css-extract-plugin
export default {"textview":"b4f83117556c67acb04d"};